export default __webpack_public_path__ + "static/marcallcase1-2edcc51990a5eb4a77152843b1a2d417.png";